export default __webpack_public_path__ + "static/media/megaphone.b1a7a86c.webp";